module.exports = __webpack_public_path__ + "static/img/jpspot.36cb3b8d.png";